import { Navigate, useLocation } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { useReporting } from '@/reporting';
import { filterAllowedParams } from '@/utils/filterAllowedParams';

const NavigateWithRedirect = ({ to }: { to: string }) => {
  const { trackEnterpriseEvent } = useReporting();
  const { pathname, search } = useLocation();
  const filteredSearch = filterAllowedParams(search);

  useEffectOnce(() => {
    trackEnterpriseEvent('user::redirected', {
      requestedPath: pathname,
    });
  });

  return <Navigate to={`${to}${filteredSearch}`} />;
};

export default NavigateWithRedirect;
